import { Hair } from '@/assets/images';
import type { IAvatarAccessory } from '../types';

export const HAIR: IAvatarAccessory[] = [
  {
    id: 'H037',
    available: true,
    colorPicker: true,
    name: 'Hair_Chrest',
    icon: <img src={Hair.Hair37} />,
    colors: ['#392827', '#151515', '#8C4900', '#BE8140']
  },
  {
    id: 'H043',
    available: true,
    colorPicker: true,
    name: 'Hair_CurlyUp',
    icon: <img src={Hair.Hair43} />,
    colors: ['#392827', '#151515', '#8C4900', '#BE8140']
  },
  {
    id: 'H044',
    available: true,
    colorPicker: true,
    name: 'Hair_Curly',
    icon: <img src={Hair.Hair44} />,
    colors: ['#392827', '#151515', '#8C4900', '#BE8140']
  },
  {
    id: 'H045',
    available: true,
    colorPicker: true,
    name: 'Hair_Wavy',
    icon: <img src={Hair.Hair45} />,
    colors: ['#392827', '#151515', '#8C4900', '#BE8140']
  },
  {
    id: 'H046',
    available: true,
    colorPicker: true,
    name: 'Hair_Headscarf',
    icon: <img src={Hair.Hair46} />,
    colors: ['#151515', '#A89386', '#8DA8C4', '#DFADB6']
  },
  {
    id: 'H047',
    available: true,
    colorPicker: true,
    name: 'Hair_HeadscarfAlt1',
    icon: <img src={Hair.Hair47} />,
    colors: ['#151515', '#A89386', '#8DA8C4', '#DFADB6']
  },
  {
    id: 'H048',
    available: true,
    colorPicker: true,
    name: 'Hair_HeadscarfAlt2',
    icon: <img src={Hair.Hair48} />,
    colors: ['#151515', '#A89386', '#8DA8C4', '#DFADB6']
  },
  {
    id: 'H049',
    available: true,
    colorPicker: true,
    name: 'Hair_HeadscarfAlt3',
    icon: <img src={Hair.Hair49} />,
    colors: ['#151515', '#A89386', '#8DA8C4', '#DFADB6']
  },
  {
    id: 'H050',
    available: true,
    colorPicker: true,
    name: 'Hair_HeadscarfAlt4',
    icon: <img src={Hair.Hair50} />,
    colors: ['#151515', '#A89386', '#8DA8C4', '#DFADB6']
  },
  {
    id: 'H051',
    available: true,
    colorPicker: true,
    name: 'Hair_HeadscarfAlt5',
    icon: <img src={Hair.Hair51} />,
    colors: ['#151515', '#A89386', '#8DA8C4', '#DFADB6']
  },
  {
    id: 'H052',
    available: true,
    colorPicker: true,
    name: 'Hair_Turban',
    icon: <img src={Hair.Hair52} />,
    colors: ['#FFFFFF', '#151515', '#A89386', '#8DA8C4']
  },
  {
    id: 'H053',
    available: true,
    colorPicker: true,
    name: 'Hair_TurbanAlt2',
    icon: <img src={Hair.Hair53} />,
    colors: ['#FFFFFF', '#151515', '#A89386', '#8DA8C4']
  },
  {
    id: 'H054',
    available: true,
    colorPicker: true,
    name: 'Hair_TurbanAlt3',
    icon: <img src={Hair.Hair54} />,
    colors: ['#FFFFFF', '#151515', '#A89386', '#8DA8C4']
  },
  {
    id: 'H055',
    available: true,
    colorPicker: true,
    name: 'Hair_TurbanAlt4',
    icon: <img src={Hair.Hair55} />,
    colors: ['#FFFFFF', '#151515', '#A89386', '#8DA8C4']
  },
  {
    id: 'H056',
    available: true,
    colorPicker: true,
    name: 'Hair_TurbanAlt5',
    icon: <img src={Hair.Hair56} />,
    colors: ['#FFFFFF', '#151515', '#A89386', '#8DA8C4']
  },
  {
    id: 'H001',
    available: true,
    colorPicker: true,
    name: 'Hair_Drinkingcap',
    icon: <img src={Hair.Hair1} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  {
    id: 'H002',
    available: true,
    colorPicker: false,
    name: 'Hair_HappyMeal',
    icon: <img src={Hair.Hair2} />
  },
  {
    id: 'H003',
    available: true,
    colorPicker: false,
    name: 'Hair_HappyMeal2',
    icon: <img src={Hair.Hair3} />
  },
  {
    id: 'H004',
    available: true,
    colorPicker: true,
    name: 'Hair_SuperAfro',
    icon: <img src={Hair.Hair4} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  {
    id: 'H005',
    available: true,
    colorPicker: true,
    name: 'Hair_LongCurly',
    icon: <img src={Hair.Hair5} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  {
    id: 'H006',
    available: true,
    colorPicker: true,
    name: 'Hair_Afro',
    icon: <img src={Hair.Hair6} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  {
    id: 'H007',
    available: true,
    colorPicker: true,
    name: 'Hair_EarWarmers',
    icon: <img src={Hair.Hair7} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  {
    id: 'H008',
    available: true,
    colorPicker: true,
    name: 'Hair_Andersaan',
    icon: <img src={Hair.Hair8} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  {
    id: 'H009',
    available: true,
    colorPicker: true,
    name: 'Hair_Chef',
    icon: <img src={Hair.Hair9} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  {
    id: 'H010',
    available: true,
    colorPicker: true,
    name: 'Hair_Wizard',
    icon: <img src={Hair.Hair10} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  {
    id: 'H011',
    available: true,
    colorPicker: true,
    name: 'Hair_Pirate',
    icon: <img src={Hair.Hair11} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  {
    id: 'H012',
    available: true,
    colorPicker: true,
    name: 'Hair_CapTail',
    icon: <img src={Hair.Hair12} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  {
    id: 'H013',
    available: true,
    colorPicker: true,
    name: 'Hair_Cap',
    icon: <img src={Hair.Hair13} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  {
    id: 'H014',
    available: true,
    colorPicker: true,
    name: 'Hair_Beanie',
    icon: <img src={Hair.Hair14} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  {
    id: 'H015',
    available: true,
    colorPicker: true,
    name: 'Hair_Baby',
    icon: <img src={Hair.Hair15} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  {
    id: 'H016',
    available: true,
    colorPicker: true,
    name: 'Hair_Kuif',
    icon: <img src={Hair.Hair16} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  {
    id: 'H017',
    available: true,
    colorPicker: true,
    name: 'Hair_Manbun',
    icon: <img src={Hair.Hair17} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  {
    id: 'H018',
    available: true,
    colorPicker: true,
    name: 'Hair_Cornrows',
    icon: <img src={Hair.Hair18} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  {
    id: 'H019',
    available: true,
    colorPicker: true,
    name: 'Hair_LongTail',
    icon: <img src={Hair.Hair19} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  {
    id: 'H020',
    available: true,
    colorPicker: true,
    name: 'Hair_LongKnot',
    icon: <img src={Hair.Hair20} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  {
    id: 'H021',
    available: true,
    colorPicker: true,
    name: 'Hair_Bob',
    icon: <img src={Hair.Hair21} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  {
    id: 'H022',
    available: true,
    colorPicker: true,
    name: 'Hair_MLK',
    icon: <img src={Hair.Hair22} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  {
    id: 'H023',
    available: true,
    colorPicker: false,
    name: 'Hair_Cat',
    icon: <img src={Hair.Hair23} />
  },
  {
    id: 'H024',
    available: true,
    colorPicker: true,
    name: 'Hair_Costanza',
    icon: <img src={Hair.Hair24} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  {
    id: 'H025',
    available: true,
    colorPicker: false,
    name: 'Hair_Helmet_1',
    icon: <img src={Hair.Hair25} />
  },
  {
    id: 'H026',
    available: true,
    colorPicker: false,
    name: 'Hair_Headscarf',
    icon: <img src={Hair.Hair26} />,
    colors: ['#DB0007', '#FFBC0D', '#33BFD2', '#E97B98']
  },
  {
    id: 'H027',
    available: true,
    colorPicker: true,
    name: 'Hair_Emo',
    icon: <img src={Hair.Hair27} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  {
    id: 'H028',
    available: true,
    colorPicker: true,
    name: 'Hair_TaxiDriver',
    icon: <img src={Hair.Hair28} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  {
    id: 'H029',
    available: true,
    colorPicker: true,
    name: 'Hair_Caring',
    icon: <img src={Hair.Hair29} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  {
    id: 'H030',
    available: true,
    colorPicker: true,
    name: 'Hair_Frida',
    icon: <img src={Hair.Hair30} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  {
    id: 'H031',
    available: true,
    colorPicker: true,
    name: 'Hair_Mobster',
    icon: <img src={Hair.Hair31} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  {
    id: 'H032',
    available: true,
    colorPicker: false,
    name: 'Hair_Amalia',
    icon: <img src={Hair.Hair32} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  {
    id: 'H033',
    available: true,
    colorPicker: true,
    name: 'Hair_Senna',
    icon: <img src={Hair.Hair33} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  {
    id: 'H034',
    available: true,
    colorPicker: false,
    name: 'Hair_Helmet',
    icon: <img src={Hair.Hair34} />
  },
  {
    id: 'H035',
    available: true,
    colorPicker: true,
    name: 'Hair_Einstein',
    icon: <img src={Hair.Hair35} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  {
    id: 'H036',
    available: true,
    colorPicker: true,
    name: 'Hair_Goodboy',
    icon: <img src={Hair.Hair36} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  /* {
    id: 'H038',
    available: false,
    colorPicker: true,
    name: 'X_Hair_Beatle',
    icon: <img src={Hair.Hair38} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  {
    id: 'H039',
    available: false,
    colorPicker: true,
    name: 'X_Hair_Diana',
    icon: <img src={Hair.Hair39} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  {
    id: 'H040',
    available: false,
    colorPicker: true,
    name: 'X_Hair_Longstraight',
    icon: <img src={Hair.Hair40} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  },
  {
    id: 'H041',
    available: false,
    colorPicker: true,
    name: 'X_Hair_Pamm',
    icon: <img src={Hair.Hair41} />,
    colors: ['#8C4900', '#151515', '#BE8140', '#FFD966']
  } */
  {
    id: 'H042',
    available: true,
    colorPicker: false,
    name: 'Hair_Bald',
    icon: <img src={Hair.Hair42} />
  }
];
